import { useCallback, useEffect, useState, type FormEvent } from "react";
import { api, errMsg, fmtDate, ROLE_LABEL } from "../../api";
import { Btn, Field, Input, Notice, PageHead, Select } from "../../components/ui";
import { useMe } from "../../session";

interface S { id: string; email: string; displayName: string; role: string; totpEnabled: boolean; lastLoginAt: string | null; disabled: boolean }

export function Staff() {
  const { me } = useMe();
  const [items, setItems] = useState<S[]>([]);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [role, setRole] = useState("operador_suporte");
  const [pw, setPw] = useState("");
  const [msg, setMsg] = useState<{ kind: "ok" | "error"; text: string } | null>(null);

  const load = useCallback(() => api<{ items: S[] }>("GET", "/api/admin/staff").then((r) => setItems(r.items)).catch((e) => setMsg({ kind: "error", text: errMsg(e) })), []);
  useEffect(() => { void load(); }, [load]);

  async function create(e: FormEvent) {
    e.preventDefault();
    try {
      await api("POST", "/api/admin/staff", { email, displayName: name, role, temporaryPassword: pw });
      setMsg({ kind: "ok", text: "Usuário criado. No primeiro acesso ele deverá configurar o 2FA." });
      setEmail(""); setName(""); setPw(""); await load();
    } catch (e2) { setMsg({ kind: "error", text: errMsg(e2) }); }
  }
  async function disable(id: string) {
    try { await api("POST", `/api/admin/staff/${id}/disable`, {}); await load(); } catch (e) { setMsg({ kind: "error", text: errMsg(e) }); }
  }

  return (
    <>
      <PageHead title="Equipe administrativa" sub="Administrador Geral e Operador de Suporte. O 2FA é obrigatório para ambos." />
      {msg && <div style={{ maxWidth: 640 }}><Notice kind={msg.kind}>{msg.text}</Notice></div>}
      <div className="card" style={{ padding: 0, overflowX: "auto", marginBottom: 16 }}>
        <table>
          <thead><tr><th>Nome</th><th>E-mail</th><th>Perfil</th><th>2FA</th><th>Último acesso</th><th /></tr></thead>
          <tbody>
            {items.map((s) => (
              <tr key={s.id}>
                <td>{s.displayName}</td><td>{s.email}</td><td>{ROLE_LABEL[s.role]}</td>
                <td>{s.totpEnabled ? "Ativo" : "Pendente"}</td><td>{fmtDate(s.lastLoginAt)}</td>
                <td>{s.disabled ? <span className="pill">Desativado</span> : s.id !== me.user.id && <Btn variant="danger" onClick={() => disable(s.id)}>Desativar</Btn>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <form className="card" style={{ maxWidth: 640 }} onSubmit={create}>
        <h3 style={{ fontSize: 16, marginBottom: 12 }}>Novo usuário administrativo</h3>
        <Field label="Nome"><Input required value={name} onChange={(e) => setName(e.target.value)} /></Field>
        <Field label="E-mail"><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} /></Field>
        <Field label="Perfil">
          <Select value={role} onChange={(e) => setRole(e.target.value)}>
            <option value="operador_suporte">Operador de Suporte</option><option value="administrador_geral">Administrador Geral</option>
          </Select>
        </Field>
        <Field label="Senha temporária"><Input type="password" autoComplete="new-password" required minLength={10} value={pw} onChange={(e) => setPw(e.target.value)} /></Field>
        <Btn type="submit">Criar usuário</Btn>
      </form>
    </>
  );
}
